import { EAnalyticsFieldName, EFieldName } from '../constants';

export const mapFieldNameToAnalyticsFieldName: Record<EFieldName, EAnalyticsFieldName> = {
  [EFieldName.ObjectCost]: EAnalyticsFieldName.ObjectCost,
  [EFieldName.DownPayment]: EAnalyticsFieldName.DownPayment,
  [EFieldName.loanTermYears]: EAnalyticsFieldName.LoanTermYears,
  [EFieldName.benefitProgram]: EAnalyticsFieldName.BenefitProgram,
};
